// src/components/prodComboBox.js
// Igual que ProdListBut, pero como input editable: permite elegir de la
// lista desplegable (datalist) o digitar la referencia manualmente.
import React, { useEffect, useId, useState, useContext } from "react";
import { getProducts } from "../api";
import { LanguageContext } from "../context/LanguageContext";

const ProdComboBox = ({ id_c, value, onSelect }) => {
  const { t } = useContext(LanguageContext);
  const [data, setData] = useState(null);
  const datalistId = useId();

  useEffect(() => {
    const fetchData = async () => {
      const result = await getProducts(id_c);
      setData(result);
    };
    fetchData();
  }, [id_c]);

  if (!data) return <p>{t("MList1")}</p>;

  return (
    <>
      <input
        className="input1"
        type="text"
        list={datalistId}
        value={value || ""}
        onChange={(e) => onSelect(e.target.value)}
        placeholder={t("MList2") || "Selecciona o digita la referencia"}
        autoComplete="off"
        required
      />
      <datalist id={datalistId}>
        {data.products.map((product) => (
          <option key={product.id_prod} value={product.id_prod} />
        ))}
      </datalist>
    </>
  );
};

export default ProdComboBox;
